const canApplyProStaffDiscount = (
  productTags: string[],
  hasSalePrice: boolean
) => productTags?.includes('prostaff_eligible') && !hasSalePrice;

export default canApplyProStaffDiscount;
